"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleName = exports.toolLabel = exports.isUserAnsweredTool = exports.isPausingTool = exports.isConfirmTool = exports.describeTool = exports.confirmMessagesOf = exports.USER_ANSWERED_TOOL_NAMES = exports.UNREGISTERED_TOOL_NAMES = exports.TOOL_DESCRIPTORS = exports.TOOL_CATALOG = exports.PAUSING_TOOL_NAMES = exports.CONFIRM_TOOL_NAMES = void 0;
const village_interface_1 = require("@llj/auth-service-interface/dist/entities/village.interface");
Object.defineProperty(exports, "ModuleName", { enumerable: true, get: function () { return village_interface_1.ModuleName; } });
const TOOL_CATALOG = {
    calculate: {
        name: 'calculate',
        label: '計算算式',
        description: '<capability>計算一整條算式並回傳數值，例如出席率、百分比、平均。</capability>\n' +
            '<boundaries>不查任何資料：要代入的數字須先用其他工具查到。</boundaries>\n' +
            '<rules>\n' +
            '- 需要數字結果時用這支算，不要心算；整條算式一次交給它，不要拆成多次呼叫。\n' +
            '- 出錯時不回數值，照錯誤說明指出的位置修正算式再呼叫，不要把錯誤當成答案。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: [],
        requiresModules: [],
        injects: [],
    },
    add: {
        name: 'add',
        label: '計算加總',
        description: '把兩個數字相加，回傳總和。多個數字要相加時逐次呼叫。',
        effect: 'read',
        needsApproval: false,
        requires: [],
        requiresModules: [],
        injects: [],
    },
    divide: {
        name: 'divide',
        label: '計算除法',
        description: '把第一個數字除以第二個數字，回傳商。除數為零時回傳錯誤而非數值。',
        effect: 'read',
        needsApproval: false,
        requires: [],
        requiresModules: [],
        injects: [],
    },
    findPlaybooks: {
        name: 'findPlaybooks',
        label: '查情境指引',
        description: '<capability>查預先寫好的情境指引：辦事步驟、規定的處理方式與對外回覆口徑，查到的是要你照著做的指示。</capability>\n' +
            '<boundaries>法規、公文範本、案例、新聞這類參考資料改用查知識庫；系統畫面怎麼操作改用查使用手冊。</boundaries>\n' +
            '<rules>\n' +
            '- 碰到辦事步驟、規定或對外說法的問題，先查一次有沒有現成的指引。\n' +
            '- 先用查詢詞找出標題，對得上的那幾份再取回完整內文，照著做。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: [],
        requiresModules: [],
        injects: [],
    },
    searchKnowledge: {
        name: 'searchKnowledge',
        label: '查知識庫',
        description: '<capability>查知識庫的參考資料：法規、公文範本、作業程序、案例與新聞，涵蓋全域資料與自行上傳的文件。</capability>\n' +
            '<boundaries>這裡是要你自己讀完判斷的參考資料；預先寫好、要照著做的流程與對外說法改用查情境指引，兩邊都可能有料時先查情境指引。</boundaries>\n' +
            '<rules>\n' +
            '- 整理成答案而不是整段照抄，並講出依據哪一份文件、屬於全域或自行上傳；文件有標籤時一併講出。\n' +
            '- 查不到時照實說知識庫裡沒有相關資料，不要自行編造。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: [],
        requiresModules: [],
        injects: ['villageId'],
    },
    searchActivities: {
        name: 'searchActivities',
        label: '查詢活動列表',
        description: '<capability>查詢看得到的活動列表，可依名稱關鍵字、狀態、時間區間與活動的開關設定篩選；每筆回活動名稱、起訖時間與報名時間。</capability>\n' +
            '<boundaries>不含任何報名者名單，名單改用查詢報名資料；活動怎麼設定的（地點、連結、注意事項、名額、票種價格、報名題目）改用查活動設定。</boundaries>',
        effect: 'read',
        needsApproval: false,
        requires: ['VIEW_ACTIVITY'],
        requiresModules: [village_interface_1.ModuleName.ACTIVITY_MODULE],
        injects: ['villageId', 'allowedActivityIds'],
    },
    getActivityDetails: {
        name: 'getActivityDetails',
        label: '查活動設定',
        description: '<capability>查指定活動的完整設定，也可用來比較幾場活動差在哪：時間、地點、連結、說明文字、各項開關與設定值、票種與價格、標籤，以及報名題目（fields）與報名基本欄位（alwaysAvailableFields）。</capability>\n' +
            '<boundaries>只回活動本身的設定，不含任何報名者的資料；報名內容改用查詢報名資料或統計報名資料；要找有哪些活動改用查詢活動列表。</boundaries>\n' +
            '<rules>\n' +
            '- 時間皆為台灣時間；報名題目已照後台順序排好，介紹時照這個順序講。\n' +
            '- 沒有明確設定過的舊活動，開關一律視為關閉。\n' +
            '- 查不到或看不到的活動會另外列出，其餘照常回。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: ['VIEW_ACTIVITY'],
        requiresModules: [village_interface_1.ModuleName.ACTIVITY_MODULE],
        injects: ['villageId', 'allowedActivityIds'],
    },
    getActivityFields: {
        name: 'getActivityFields',
        label: '查詢報名欄位',
        description: '查詢某個活動的報名欄位，回傳兩組：fields 是這個活動開啟的題目（代號與題目名稱），' +
            'alwaysAvailableFields 是報名基本欄位（繳費、報到、錄取、審核狀態等），不論活動怎麼設定都拿得到。' +
            '要用 searchActivityReplies 取報名資料前，先用這支確認可以填哪些 fields。' +
            '⚠️ 只回欄位設定，不含任何人的填答內容。',
        effect: 'read',
        needsApproval: false,
        requires: ['VIEW_REPLY'],
        requiresModules: [village_interface_1.ModuleName.ACTIVITY_MODULE],
        injects: ['villageId', 'allowedActivityIds'],
    },
    searchActivityReplies: {
        name: 'searchActivityReplies',
        label: '查詢報名資料',
        description: '<capability>查詢報名資料的完整名單，可查一場、多場或所有看得到的活動，可依活動日期或報名時間限定期間，並用條件只取符合的報名，例如還沒繳費、已繳費但未報到、某人幫誰代填。</capability>\n' +
            '<boundaries>只要人數或分組計數改用統計報名資料；問造冊上的某一位里民報過什麼改用查個人報名紀錄。依報名表上填的姓名、電話或代填人找人（這個人可能不在造冊裡）用這支。</boundaries>\n' +
            '<rules>\n' +
            '- 要的是名單裡的某些人時用條件縮小，不要撈整份名單自己比對。\n' +
            '- 回傳的範圍有排除的活動時，要一併告訴使用者。\n' +
            '- 活動沒開繳費或簽到時，回傳附註會點名；那些活動的未繳、未報到不能當成事實講。\n' +
            '- 附註說結果未完整時，沒翻完或沒縮小條件前，不要下「全部都是」「沒有任何人」這類結論。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: ['VIEW_REPLY'],
        requiresModules: [village_interface_1.ModuleName.ACTIVITY_MODULE],
        injects: ['villageId', 'allowedActivityIds'],
    },
    countActivityReplies: {
        name: 'countActivityReplies',
        label: '統計報名資料',
        description: '<capability>統計報名資料：總筆數、不重複人數、依欄位分組的計數、加總平均等數字，以及依人排名（例如誰參加最多次）；可統計一場、多場或全部活動，並依活動日期或報名時間限定期間。</capability>\n' +
            '<boundaries>不回名單，除了排名之外不指向任何一位報名者；要看是哪些人改用查詢報名資料。</boundaries>\n' +
            '<rules>\n' +
            '- 問人數、比例、報到或繳費幾位、排名時用這支一次算完，不要撈名單自己數。\n' +
            '- 回傳的範圍只涵蓋部分活動時，回答要一併說明。\n' +
            '- 回答時一併講出回傳標明的時間範圍。\n' +
            '- 分組名是報名資料的原始值，不做同義詞合併：看到「男」與「男性」不要自己併起來。\n' +
            '- 講人數時要交代沒綁定會員、無法去重的筆數。\n' +
            '- 分組結果太多時回「需要補充資訊」，不是出錯也不是回前幾組；請換欄位或加過濾條件再查。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: ['VIEW_REPLY'],
        requiresModules: [village_interface_1.ModuleName.ACTIVITY_MODULE],
        injects: ['villageId', 'allowedActivityIds'],
    },
    getVillagerFields: {
        name: 'getVillagerFields',
        label: '查詢里民欄位',
        description: '<capability>查里民造冊有哪些欄位：一律會回的基本欄位、要指名才會回的欄位（代號、中文名、資料型別），以及只能拿來分組的合成欄位，例如年齡層 ageRange、LINE 帳號 lineAccount。</capability>\n' +
            '<boundaries>只回欄位清單，不含任何里民的資料。participateRecords 是手動登記的參與紀錄，不是活動報名；問參加過哪些活動改用查詢報名資料。</boundaries>\n' +
            '<rules>\n' +
            '- 欄位代號就是查詢里民的條件與要取的欄位、統計里民的分組要填的值。\n' +
            '- 每一欄標明能不能當條件（queryable）與能不能分組（groupable）；地址欄位只能用地址部分比對。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: ['VIEW_VILLAGER_INFO'],
        requiresModules: [village_interface_1.ModuleName.VILLAGER_INFO_MODULE],
        injects: [],
    },
    countVillagers: {
        name: 'countVillagers',
        label: '統計里民人數',
        description: '<capability>統計造冊的里民人數，可先篩選再依任一可分組欄位分組計數；也能找重複（同一個身分證、同一戶、同一個 LINE 帳號），並列出每組是誰。</capability>\n' +
            '<boundaries>預設只回計數，不指向任何一位里民；要看一群人的明細改用查詢里民名冊。</boundaries>\n' +
            '<rules>\n' +
            '- 分組名是造冊裡的原始值，不做同義詞合併：看到「男」與「男性」不要自己併起來；身分證與地址例外，會先正規化。\n' +
            '- 回傳的 total 是篩選後總人數；問幾組、幾戶、幾個帳號看 groupCount，問這些組合計幾人看 groupedTotal。\n' +
            '- 分組或列出的成員太多時回「需要補充資訊」，不是出錯也不是回前幾組；請換欄位、加條件或提高門檻再查。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: ['VIEW_VILLAGER_INFO'],
        requiresModules: [village_interface_1.ModuleName.VILLAGER_INFO_MODULE],
        injects: ['villageId'],
    },
    searchVillagers: {
        name: 'searchVillagers',
        label: '查詢里民名冊',
        description: '<capability>查詢符合某些條件的一群里民的造冊資料，回完整名單，例如某一鄰或某年出生的里民。</capability>\n' +
            '<boundaries>問某一個人的資料改用查里民明細；只要人數或分組計數改用統計里民人數。沒有全文搜尋，只能指名欄位比對。</boundaries>\n' +
            '<rules>\n' +
            '- 找同住的人要比對地址，不是看父母配偶欄位：先取得他的地址，再以路名＋門牌部分比對。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: ['VIEW_VILLAGER_INFO'],
        requiresModules: [village_interface_1.ModuleName.VILLAGER_INFO_MODULE],
        injects: ['villageId'],
    },
    getVillagerDetail: {
        name: 'getVillagerDetail',
        label: '查里民明細',
        description: '<capability>用姓名或電話查一位里民的造冊明細，回這個人在造冊裡填過的所有欄位。</capability>\n' +
            '<boundaries>問的是某一個人就用這支，不要自己組條件去查整份名冊。</boundaries>\n' +
            '<rules>\n' +
            '- 姓名是模糊比對，多筆命中是常態：會回「需要補充資訊」並列出候選，請轉述給使用者、等他指認後再查一次，不要自己挑一個。\n' +
            '- 查不到時請換個查法（例如只給名不給姓），不要直接斷定造冊裡沒有這個人。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: true,
        requires: ['VIEW_VILLAGER_INFO'],
        requiresModules: [village_interface_1.ModuleName.VILLAGER_INFO_MODULE],
        injects: ['villageId'],
    },
    searchVillagerReplies: {
        name: 'searchVillagerReplies',
        label: '查個人報名紀錄',
        description: '<capability>反查某一位里民報名過哪些活動，每筆帶活動名稱、活動日期與報名基本欄位（報名時間、錄取、報到、繳費、票種、審核狀態），可依活動日期或報名時間限定期間。</capability>\n' +
            '<boundaries>不要一個活動一個活動去查報名資料。依報名表上填的姓名、電話或代填人去找，或這個人不在造冊裡，改用查詢報名資料。</boundaries>\n' +
            '<rules>\n' +
            '- 命中多位里民時會回「需要補充資訊」並列出候選，請轉述給使用者、等他指認後再查一次，不要自己挑一個。\n' +
            '- 比對只靠姓名與電話，結果一律附說明：零筆不代表沒報名過，有結果也不代表只有這幾筆，請把說明一併告訴使用者。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: ['VIEW_VILLAGER_INFO', 'VIEW_REPLY'],
        requiresModules: [village_interface_1.ModuleName.VILLAGER_INFO_MODULE, village_interface_1.ModuleName.ACTIVITY_MODULE],
        injects: ['villageId', 'allowedActivityIds'],
    },
    searchDocuments: {
        name: 'searchDocuments',
        label: '查詢公文列表',
        description: '<capability>查詢文件管理裡的公文列表，可依發文機關、主旨、發文日期、標籤或全文關鍵字找；每筆回主旨、發文機關、文號、發文日期、標籤與附檔名稱。</capability>\n' +
            '<boundaries>不含公文內容與附檔內文，要看某一份的內容、摘要或附檔改用查公文明細。文件管理裡的公文都查得到，與有沒有加入知識庫無關。</boundaries>\n' +
            '<rules>\n' +
            '- 多個條件同時給時，公文要全部符合。\n' +
            '- 總數比這一頁多時，回答要講明總共幾份、目前列的是哪一段。\n' +
            '- 回傳附註說有公文認不出發文日期而沒列入時，要一併轉述。\n' +
            '- 查不到只表示這組條件查不到，不代表沒有這類公文；照實告訴使用者並建議換個條件。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: ['DOCUMENT'],
        requiresModules: [village_interface_1.ModuleName.DOCUMENT_MODULE],
        injects: ['villageId'],
    },
    getDocumentDetail: {
        name: 'getDocumentDetail',
        label: '查公文明細',
        description: '<capability>查一份公文的明細：主旨、發文機關、文號、發文日期、標籤、內容、內容摘要與附檔清單，需要時可一併讀附檔擷取出的文字。</capability>\n' +
            '<boundaries>只看一份公文；要找有哪些公文、有幾份改用查詢公文列表。</boundaries>\n' +
            '<rules>\n' +
            '- 附檔文字被截斷時，回答要講明只讀到前面一部分；讀不到文字的附檔照實說。\n' +
            '- 查不到時（代號不對、已刪除或不在可見範圍內，回應都相同）照實說查不到，不要猜是哪一種原因。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: ['DOCUMENT'],
        requiresModules: [village_interface_1.ModuleName.DOCUMENT_MODULE],
        injects: ['villageId'],
    },
    findSystemManuals: {
        name: 'findSystemManuals',
        label: '查使用手冊',
        description: '<capability>查系統使用手冊：本系統各功能畫面的操作步驟，以及某個功能在哪個選單、在哪裡設定。</capability>\n' +
            '<boundaries>辦事流程與對外說法改用查情境指引；法規、公文這類參考資料改用查知識庫。</boundaries>\n' +
            '<rules>\n' +
            '- 先列出目錄，挑出對得上的那幾份再取回完整內文；照內文回答，並講出依據的是哪一份手冊。\n' +
            '- 查不到時照實說手冊裡沒有這部分的說明，不要自行編造操作步驟。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: [],
        requiresModules: [],
        injects: [],
    },
    getToolGuide: {
        name: 'getToolGuide',
        label: '查工具說明',
        description: '<capability>查同一個模組系列的工具之間怎麼搭配：使用順序與名詞對照，只列這一輪你實際拿得到的工具。</capability>\n' +
            '<rules>\n' +
            '- 需要同一模組的多支工具搭配才能回答時先查這支，照回傳的順序做；單一工具就答得完的問題不必查。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: [],
        requiresModules: [],
        injects: [],
    },
    askUserQuestions: {
        name: 'askUserQuestions',
        label: '向你提問',
        description: '<capability>向使用者提出 1～4 個問題並暫停等他回答，用在缺了關鍵資訊就做不下去的請求，例如要辦活動卻沒講時間、形式、人數。</capability>\n' +
            '<boundaries>可以合理預設的細節、一般的確認、使用者已經講過的事，以及查得到或推得出的資訊都不要問。</boundaries>\n' +
            '<rules>\n' +
            '- 出題前只查出題需要的資料，名單、逐筆明細這類細節留到使用者回答後再查。\n' +
            '- 呼叫後這一輪就停住，答案會以工具結果回來；開場白就是你的回覆，呼叫前不要另外講一遍。\n' +
            '- 被略過的題目不要馬上再問，改用合理的預設並在回覆中說明用了什麼，或說明還缺什麼。\n' +
            '- 使用者沒回答而直接輸入下一則訊息時，依那則訊息處理，不要重問同一組提問。\n' +
            '</rules>',
        effect: 'read',
        needsApproval: false,
        requires: [],
        requiresModules: [],
        injects: [],
    },
    createActivity: {
        name: 'createActivity',
        label: '建立活動',
        description: '<capability>幫使用者建立一場活動。呼叫後不會馬上建立：畫面會出一張確認卡，使用者按確認才會建立。</capability>\n' +
            '<rules>\n' +
            '- 最少要有活動名稱、活動開始與結束時間、地點；推不出來時先問使用者，不要用假資料填。\n' +
            '- 其餘設定（名額、報名題目、公開與否等）使用者沒提就不要問，用預設值即可。\n' +
            '- 參數缺漏或互相矛盾時會回「需要補充資訊」，照那句話問使用者或修正後再呼叫。\n' +
            '</rules>',
        effect: 'write:confirm',
        needsApproval: true,
        requires: ['CREATE_ACTIVITY'],
        requiresModules: [village_interface_1.ModuleName.ACTIVITY_MODULE],
        injects: ['villageId'],
        confirmMessages: {
            executed: '使用者已在確認卡上按下確認，活動已建立完成。' +
                '請直接告訴使用者活動已建立（名稱見 result），可接著提議下一步；不要再請使用者確認或重新建立。',
            cancelled: '使用者取消了這次建立活動，活動未建立。',
            interrupted: '使用者中斷了建立活動流程（改為直接輸入訊息），活動未建立；' +
                '若使用者是針對卡片內容提問或要求修改，請依新訊息重新呼叫建立活動。',
        },
    },
};
exports.TOOL_CATALOG = TOOL_CATALOG;
const UNREGISTERED_TOOL_NAMES = [
    TOOL_CATALOG.getActivityFields.name,
    TOOL_CATALOG.add.name,
    TOOL_CATALOG.divide.name,
];
exports.UNREGISTERED_TOOL_NAMES = UNREGISTERED_TOOL_NAMES;
const TOOL_DESCRIPTORS = Object.values(TOOL_CATALOG)
    .filter((descriptor) => !UNREGISTERED_TOOL_NAMES.includes(descriptor.name));
exports.TOOL_DESCRIPTORS = TOOL_DESCRIPTORS;
const USER_ANSWERED_TOOL_NAMES = [TOOL_CATALOG.askUserQuestions.name];
exports.USER_ANSWERED_TOOL_NAMES = USER_ANSWERED_TOOL_NAMES;
const isUserAnsweredTool = (name) => USER_ANSWERED_TOOL_NAMES.includes(name);
exports.isUserAnsweredTool = isUserAnsweredTool;
const CONFIRM_TOOL_NAMES = Object.values(TOOL_CATALOG)
    .filter((descriptor) => descriptor.effect === 'write:confirm')
    .map((descriptor) => descriptor.name);
exports.CONFIRM_TOOL_NAMES = CONFIRM_TOOL_NAMES;
const isConfirmTool = (name) => CONFIRM_TOOL_NAMES.includes(name);
exports.isConfirmTool = isConfirmTool;
const PAUSING_TOOL_NAMES = [...USER_ANSWERED_TOOL_NAMES, ...CONFIRM_TOOL_NAMES];
exports.PAUSING_TOOL_NAMES = PAUSING_TOOL_NAMES;
const isPausingTool = (name) => PAUSING_TOOL_NAMES.includes(name);
exports.isPausingTool = isPausingTool;
const confirmMessagesOf = (name) => {
    const descriptor = TOOL_CATALOG[name];
    return descriptor?.confirmMessages ?? {
        executed: '使用者已在確認卡上按下確認，這項操作已執行完成。請直接告訴使用者結果，不要再請使用者確認。',
        cancelled: '使用者按下取消，這項操作沒有執行。',
        interrupted: '使用者沒有確認、改為直接輸入下一則訊息，這項操作已中斷，沒有執行。',
    };
};
exports.confirmMessagesOf = confirmMessagesOf;
const describeTool = (name) => TOOL_CATALOG[name].description;
exports.describeTool = describeTool;
const toolLabel = (name) => (Object.prototype.hasOwnProperty.call(TOOL_CATALOG, name) ?
    TOOL_CATALOG[name].label : name);
exports.toolLabel = toolLabel;
//# sourceMappingURL=tool-catalogue.interface.js.map